// extracted by mini-css-extract-plugin
export default {"backButton":"DD7fFVZ_v46Am2iLCzEK"};